import { create } from "zustand";

interface DeceasedDetailsState {
  deceasedDetails: {
    title: string;
    initials: string;
    firstName: string;
    lastName: string;
    relationship: string;
    dateOfBirth: string;
    dateOfDeath: string;
    causeOfDeath: string;
    identificationNumber: string;
    identificationType: string;
    stillBorn: boolean;
    gestationWeeks: string;
    signsOfLifeAfterDelivery: boolean | null;
    intentionalTerminationOfPregnancy: boolean | null;
    motherName: string;
    motherSurname: string;
    memberCard: boolean;
    isNaturalDeath: boolean;
    isBodyRemovalRequired: boolean;
  };
  setDeceasedDetails: (
    data: Partial<DeceasedDetailsState["deceasedDetails"]>
  ) => void;
  resetDeceasedDetails: () => void;
}

export const useDeceasedFormStore = create<DeceasedDetailsState>((set) => ({
  deceasedDetails: {
    title: "",
    initials: "",
    firstName: "",
    lastName: "",
    relationship: "",
    dateOfBirth: "",
    dateOfDeath: "",
    causeOfDeath: "",
    identificationNumber: "",
    identificationType: "ID",
    stillBorn: false,
    gestationWeeks: "",
    signsOfLifeAfterDelivery: null,
    intentionalTerminationOfPregnancy: null,
    motherName: "",
    motherSurname: "",
    memberCard: false,
    isNaturalDeath: false,
    isBodyRemovalRequired:false
  },
  setDeceasedDetails: (data) =>
    set((state) => ({
      deceasedDetails: {
        ...state.deceasedDetails,
        ...data,
      },
    })),
  resetDeceasedDetails: () =>
    set(() => ({
      deceasedDetails: {
        title: "",
        initials: "",
        firstName: "",
        lastName: "",
        relationship: "",
        dateOfBirth: "",
        dateOfDeath: "",
        causeOfDeath: "",
        identificationNumber: "",
        identificationType: "ID",
        stillBorn: false,
        gestationWeeks: "",
        signsOfLifeAfterDelivery: null,
        intentionalTerminationOfPregnancy: null,
        motherName: "",
        motherSurname: "",
        memberCard: false,
        isNaturalDeath: false,
        isBodyRemovalRequired:false,
      },
    })),
}));
